module.exports = __webpack_public_path__ + "static/media/phd_kagarama2.00ffe823.jpg";